import SkyPredict from './SkyPredict';
export default SkyPredict;
